var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.4609C14.4706 19.4609 18.5 15.4315 18.5 10.4609C18.5 5.49037 14.4706 1.46094 9.5 1.46094C4.52944 1.46094 0.5 5.49037 0.5 10.4609C0.5 15.4315 4.52944 19.4609 9.5 19.4609Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2423 14.359H7.3456C5.89727 14.359 5.41602 13.3965 5.41602 12.4294V8.5702C5.41602 7.1219 5.89727 6.64062 7.3456 6.64062H10.2423C11.6906 6.64062 12.1718 7.1219 12.1718 8.5702V12.4294C12.1718 13.8777 11.686 14.359 10.2423 14.359Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.446 13.838L12.1719 12.9443V10.0522L13.446 9.15851C14.0694 8.72301 14.5827 8.98891 14.5827 9.75431V13.2468C14.5827 14.0122 14.0694 14.278 13.446 13.838Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77148 10.043C10.1512 10.043 10.459 9.73517 10.459 9.35547C10.459 8.97577 10.1512 8.66797 9.77148 8.66797C9.39178 8.66797 9.08398 8.97577 9.08398 9.35547C9.08398 9.73517 9.39178 10.043 9.77148 10.043Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartVideoIcon);
export default __webpack_public_path__ + "static/media/startVideo_icon.4b5091d82dd645e6409d768324383f44.svg";
export { ForwardRef as ReactComponent };